(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-accordion-01"] && !Shopify.designMode) return;
  try {
    
  class YGAccordion01 extends HTMLElement {
    #sectionEl;

    constructor() {
      super();
      this.currentStepIndex = 0;
      this.mobileSwiper = null;
      this.handleMobileSlideChange = null;
      this.handleDropdownOpen = this.handleDropdownOpen.bind(this);
      this.handleProgressEnd = this.handleProgressEnd.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl;
      let isMobile = window.innerWidth < 699;

      this.#sectionEl = {
        accordionList: this.querySelectorAll(".yg-process-steps-item"),
        progressBars: this.querySelectorAll(".yg-process-steps-progress-bar"),
        controls: isMobile ? this.querySelectorAll(".yg-process-steps-content-media") : this.querySelectorAll(".yg-process-steps-media")
      };

      return this.#sectionEl;
    }

    connectedCallback() {
      document.addEventListener("YG:dropdown-open", this.handleDropdownOpen);
      document.addEventListener("YG:progress-end", this.handleProgressEnd);
      window.addEventListener("resize", this.handleResize);
      this.initMobileCarousel();

      if (this.shouldUseMobileCarousel()) {
        this.syncMobileCarouselMedia();
      }
    }

    disconnectedCallback() {
      document.removeEventListener("YG:dropdown-open", this.handleDropdownOpen);
      document.removeEventListener("YG:progress-end", this.handleProgressEnd);
      window.removeEventListener("resize", this.handleResize);

      if (this.mobileSwiper && this.handleMobileSlideChange) {
        this.mobileSwiper.off("slideChange", this.handleMobileSlideChange);
      }
    }

    handleDropdownOpen(event) {
      if (this.shouldUseMobileCarousel()) {
        return;
      }

      if (event.detail.id) {
        this.currentStep(event.detail.id);
      }
    }

    handleProgressEnd(event) {
      if (this.shouldUseMobileCarousel()) {
        return;
      }

      if (event.detail.id) {
        this.nextStep(event.detail.id);
      }
    }

    handleResize() {
      this.#sectionEl = null;
      this.initMobileCarousel();

      if (this.shouldUseMobileCarousel()) {
        this.syncMobileCarouselMedia();
      } else {
        this.pauseCarouselVideos();
      }
    }

    shouldUseMobileCarousel() {
      return this.dataset.enableMobileCarousel === "true" && window.innerWidth < 700;
    }

    get carouselContainer() {
      return this.parentElement;
    }

    initMobileCarousel() {
      const mobileSwiperEl = this.carouselContainer?.querySelector(".yg-process-steps-mobile-swiper");

      if (!mobileSwiperEl) {
        return;
      }

      const bindSwiper = () => {
        const swiperInstance = mobileSwiperEl.swiper;

        if (!swiperInstance) {
          requestAnimationFrame(bindSwiper);
          return;
        }

        if (this.mobileSwiper && this.mobileSwiper !== swiperInstance && this.handleMobileSlideChange) {
          this.mobileSwiper.off("slideChange", this.handleMobileSlideChange);
        }

        if (this.mobileSwiper === swiperInstance) {
          this.syncMobileCarouselMedia(swiperInstance);
          return;
        }

        this.mobileSwiper = swiperInstance;
        this.handleMobileSlideChange = () => {
          this.syncMobileCarouselMedia(swiperInstance);
        };

        swiperInstance.on("slideChange", this.handleMobileSlideChange);
        this.syncMobileCarouselMedia(swiperInstance);
      };

      bindSwiper();
    }

    syncMobileCarouselMedia(swiperInstance = this.mobileSwiper) {
      if (!this.shouldUseMobileCarousel() || !swiperInstance) {
        return;
      }

      this.pauseCarouselVideos();

      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex] || this.carouselContainer?.querySelector(".yg-process-steps-mobile-swiper .swiper-slide-active");
      const activeVideo = activeSlide?.querySelector("yg-video");

      if (activeVideo) {
        activeVideo.playVideo();
      }
    }

    pauseCarouselVideos() {
      this.carouselContainer?.querySelectorAll(".yg-process-steps-mobile-slide yg-video").forEach((videoEl) => {
        videoEl.pauseVideo();
      });
    }

    nextStep(id) {
      this.$sectionEl.accordionList.forEach((item, i) => {
        if (item.getAttribute("data-id") === id) {
          let indexNext = i === this.$sectionEl.accordionList.length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });

      if (!this.isCurrentStep(id)) {
        return;
      }
      this.$sectionEl.accordionList[this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      if (this.shouldUseMobileCarousel()) {
        return;
      }

      if (!this.isCurrentStep(id)) {
        return;
      }
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    isCurrentStep(id) {
      let isCurrentStep = false;
      this.$sectionEl.accordionList.forEach((item) => {
        if (item.getAttribute("data-id") === id) {
          isCurrentStep = true;
        }
      });
      return isCurrentStep;
    }

    getEffectiveId(id) {
      let isMobile = window.innerWidth < 699;
      if (isMobile) {
        return id.replace("steps-item-", "steps-item-mobile-");
      }
      return id;
    }

    setActiveControl(id) {
      this.$sectionEl.controls.forEach((item) => {
        if (item.getAttribute("data-id") === id) {
          item.classList.add("active");
        } else {
          item.classList.remove("active");
        }
      });
    }

    startProgressForId(id) {
      this.$sectionEl.progressBars?.forEach((item, i) => {
        if (item.getAttribute("data-id") === id) {
          this.currentStepIndex = i;
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      this.$sectionEl.controls.forEach((item) => {
        if (item.querySelector("yg-video")?.getAttribute("data-id") === id) {
          videoEl = item.querySelector("yg-video");
        }
      });
      return videoEl;
    }

    pauseAllVideos() {
      this.$sectionEl.controls.forEach((item) => {
        const videoEl = item.querySelector("yg-video");
        if (videoEl) {
          videoEl.pauseVideo();
        }
      });
    }

    playVideo(id) {
      let effectiveId = this.getEffectiveId(id);
      this.pauseAllVideos();
      const videoEl = this.getVideoById(effectiveId);
      if (videoEl) {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-accordion-01')) {
    window.customElements.define('yg-accordion-01', YGAccordion01);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-download-center"] && !Shopify.designMode) return;
  try {
    
  class YGDownloadCenter extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.handleInput = this.handleInput.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleModeChange = this.handleModeChange.bind(this);
      this.mobileMedia = window.matchMedia('(max-width: 699px)');
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('input', this.handleInput);
      document.addEventListener('click', this.handleDocumentClick);
      this.updateProductDropdown();
      this.applyFilters();

      if (this.mobileMedia.addEventListener) {
        this.mobileMedia.addEventListener('change', this.handleModeChange);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('input', this.handleInput);
      document.removeEventListener('click', this.handleDocumentClick);

      if (this.mobileMedia.addEventListener) {
        this.mobileMedia.removeEventListener('change', this.handleModeChange);
      }
    }

    handleClick(event) {
      const dropdownTrigger = event.target.closest('[data-dropdown-trigger]');
      if (dropdownTrigger && this.contains(dropdownTrigger)) {
        const dropdown = dropdownTrigger.closest('[data-category-dropdown], [data-product-dropdown]');
        if (!dropdown || dropdown.classList.contains('is-disabled')) {
          return;
        }

        this.toggleDropdown(dropdown);
        return;
      }

      const dropdownOption = event.target.closest('[data-dropdown-option]');
      if (dropdownOption && this.contains(dropdownOption)) {
        this.selectDropdownOption(dropdownOption);
        return;
      }

      const searchButton = event.target.closest('[data-keyword-button]');
      if (searchButton && this.contains(searchButton)) {
        this.clearCategorySelection();
        this.clearProductSelection();
        this.updateProductDropdown();
        this.applyFilters({ forceFirst: true });
        return;
      }

      const seriesToggle = event.target.closest('[data-series-toggle]');
      if (seriesToggle && this.contains(seriesToggle)) {
        this.toggleSeries(seriesToggle);
        return;
      }

      const productTrigger = event.target.closest('[data-product-trigger]');
      if (!productTrigger || !this.contains(productTrigger)) {
        return;
      }

      const productKey = productTrigger.dataset.productTrigger;

      if (this.mobileMedia.matches) {
        this.toggleMobileProduct(productKey, productTrigger.classList.contains('is-active'));
      } else {
        this.activateDesktopProduct(productKey);
      }
    }

    handleInput(event) {
      if (!event.target.matches('[data-keyword-input]')) {
        return;
      }

      this.clearCategorySelection();
      this.clearProductSelection();
      this.updateProductDropdown();
      this.applyFilters({ forceFirst: true });
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.closeAllDropdowns();
      }
    }

    handleModeChange() {
      const activeTrigger = this.querySelector('[data-product-trigger].is-active');

      if (!this.mobileMedia.matches && activeTrigger) {
        this.activateDesktopProduct(activeTrigger.dataset.productTrigger);
        return;
      }

      if (!this.mobileMedia.matches && !activeTrigger) {
        const firstTrigger = this.querySelector('[data-product-trigger]');
        if (firstTrigger) {
          this.activateDesktopProduct(firstTrigger.dataset.productTrigger);
        }
      }
    }

    toggleSeries(toggle) {
      const series = toggle.closest('[data-series]');
      const isOpen = series.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    toggleDropdown(dropdown) {
      const isOpen = dropdown.classList.contains('is-open');
      this.closeAllDropdowns(dropdown);
      this.setDropdownOpen(dropdown, !isOpen);
    }

    closeAllDropdowns(exceptDropdown = null) {
      this.querySelectorAll('[data-category-dropdown], [data-product-dropdown]').forEach((dropdown) => {
        if (dropdown !== exceptDropdown) {
          this.setDropdownOpen(dropdown, false);
        }
      });
    }

    setDropdownOpen(dropdown, isOpen) {
      const trigger = dropdown.querySelector('[data-dropdown-trigger]');
      const list = dropdown.querySelector('[data-dropdown-list]');

      dropdown.classList.toggle('is-open', isOpen);

      if (trigger) {
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      if (list) {
        list.hidden = !isOpen;
      }
    }

    selectDropdownOption(option) {
      const dropdown = option.closest('[data-category-dropdown], [data-product-dropdown]');
      const value = option.dataset.value || '';
      const label = option.textContent.trim();

      if (!dropdown || option.hidden) {
        return;
      }

      this.setDropdownValue(dropdown, value, label);
      this.setDropdownOpen(dropdown, false);

      if (dropdown.matches('[data-category-dropdown]')) {
        this.clearProductSelection();
        this.updateProductDropdown();
        this.applyFilters({ forceFirst: true });
        return;
      }

      if (dropdown.matches('[data-product-dropdown]')) {
        this.applyFilters({
          forceFirst: true,
          productKey: value,
        });
      }
    }

    setDropdownValue(dropdown, value, label = '') {
      const nextValue = value || '';
      const nextLabel = nextValue ? label : dropdown.dataset.placeholder;
      const labelElement = dropdown.querySelector('[data-dropdown-label]');

      dropdown.dataset.value = nextValue;

      if (labelElement) {
        labelElement.textContent = nextLabel || '';
      }

      dropdown.querySelectorAll('[data-dropdown-option]').forEach((option) => {
        option.setAttribute('aria-selected', option.dataset.value === nextValue ? 'true' : 'false');
      });
    }

    setDropdownDisabled(dropdown, isDisabled) {
      const trigger = dropdown ? dropdown.querySelector('[data-dropdown-trigger]') : null;

      if (!dropdown || !trigger) {
        return;
      }

      dropdown.classList.toggle('is-disabled', isDisabled);
      trigger.disabled = isDisabled;

      if (isDisabled) {
        this.setDropdownOpen(dropdown, false);
      }
    }

    updateProductDropdown() {
      const categoryDropdown = this.categoryDropdown;
      const productDropdown = this.productDropdown;

      if (!categoryDropdown || !productDropdown) {
        return;
      }

      const categoryId = this.getDropdownValue(categoryDropdown);
      this.setDropdownDisabled(productDropdown, !categoryId);

      productDropdown.querySelectorAll('[data-dropdown-option]').forEach((option) => {
        if (!option.dataset.value) {
          option.hidden = false;
          return;
        }

        const isAvailable = Boolean(categoryId) && option.dataset.categoryId === categoryId;
        option.hidden = !isAvailable;
      });

      if (!categoryId) {
        this.clearProductSelection();
        return;
      }

      const selectedOption = productDropdown.querySelector(`[data-dropdown-option][data-value="${this.getDropdownValue(productDropdown)}"]`);
      if (selectedOption && selectedOption.hidden) {
        this.clearProductSelection();
      }
    }

    applyFilters(options = {}) {
      this.updateProductDropdown();

      const firstVisibleProductKey = this.updateVisibleProducts();
      const hasVisibleProducts = Boolean(firstVisibleProductKey);
      const noResults = this.querySelector('[data-no-results]');
      const sidebar = this.querySelector('.yg-download-center__sidebar');
      const content = this.querySelector('.yg-download-center__content');

      if (noResults) {
        noResults.hidden = hasVisibleProducts;
      }

      if (sidebar) {
        sidebar.hidden = !hasVisibleProducts;
      }

      if (content) {
        content.hidden = !hasVisibleProducts;
      }

      if (!hasVisibleProducts) {
        this.deactivateAllProducts();
        return;
      }

      const activeTrigger = this.querySelector('[data-product-trigger].is-active');
      const activeProductKey = activeTrigger ? activeTrigger.dataset.productTrigger : '';
      const requestedProductKey = options.productKey || '';
      let nextProductKey = firstVisibleProductKey;

      if (requestedProductKey && this.isProductKeyVisible(requestedProductKey)) {
        nextProductKey = requestedProductKey;
      } else if (!options.forceFirst && activeProductKey && this.isProductKeyVisible(activeProductKey)) {
        nextProductKey = activeProductKey;
      }

      if (this.mobileMedia.matches) {
        this.openMobileProduct(nextProductKey);
      } else {
        this.activateDesktopProduct(nextProductKey);
      }
    }

    updateVisibleProducts() {
      let firstVisibleProductKey = '';

      this.querySelectorAll('[data-series]').forEach((series) => {
        let visibleProductsCount = 0;

        series.querySelectorAll('[data-product-item]').forEach((item) => {
          const isVisible = this.matchesCurrentFilters(item);
          item.hidden = !isVisible;

          if (isVisible) {
            visibleProductsCount += 1;
            firstVisibleProductKey = firstVisibleProductKey || item.dataset.productKey;
          }
        });

        series.hidden = visibleProductsCount === 0;

        if (visibleProductsCount > 0) {
          series.classList.add('is-open');
          const toggle = series.querySelector('[data-series-toggle]');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
          }
        }
      });

      return firstVisibleProductKey;
    }

    matchesCurrentFilters(item) {
      const categoryId = this.categoryDropdown ? this.getDropdownValue(this.categoryDropdown) : '';
      const productKey = this.productDropdown ? this.getDropdownValue(this.productDropdown) : '';
      const keyword = this.keywordInput ? this.keywordInput.value.trim().toLowerCase() : '';
      const itemTitle = item.dataset.productTitle || '';

      if (categoryId && item.dataset.categoryId !== categoryId) {
        return false;
      }

      if (productKey && item.dataset.productKey !== productKey) {
        return false;
      }

      if (keyword && !itemTitle.includes(keyword)) {
        return false;
      }

      return true;
    }

    getDropdownValue(dropdown) {
      return dropdown ? dropdown.dataset.value || '' : '';
    }

    isProductKeyVisible(productKey) {
      const item = this.querySelector(`[data-product-item][data-product-key="${productKey}"]`);
      return Boolean(item && !item.hidden);
    }

    activateDesktopProduct(productKey) {
      this.querySelectorAll('[data-product-trigger]').forEach((trigger) => {
        const isActive = trigger.dataset.productTrigger === productKey;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      this.querySelectorAll('[data-desktop-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.desktopPanel !== productKey;
      });

      this.querySelectorAll('[data-mobile-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.mobilePanel !== productKey;
      });
    }

    toggleMobileProduct(productKey, isCurrentActive) {
      this.querySelectorAll('[data-product-trigger]').forEach((trigger) => {
        trigger.classList.remove('is-active');
        trigger.setAttribute('aria-expanded', 'false');
      });

      this.querySelectorAll('[data-mobile-panel]').forEach((panel) => {
        panel.hidden = true;
      });

      if (isCurrentActive) {
        return;
      }

      this.querySelectorAll(`[data-product-trigger="${productKey}"]`).forEach((trigger) => {
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
      });

      this.querySelectorAll(`[data-mobile-panel="${productKey}"]`).forEach((panel) => {
        panel.hidden = false;
      });

      this.querySelectorAll('[data-desktop-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.desktopPanel !== productKey;
      });

      this.scrollToMobileProduct(productKey);
    }

    openMobileProduct(productKey) {
      this.querySelectorAll('[data-product-trigger]').forEach((trigger) => {
        const isActive = trigger.dataset.productTrigger === productKey;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      this.querySelectorAll('[data-mobile-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.mobilePanel !== productKey;
      });

      this.querySelectorAll('[data-desktop-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.desktopPanel !== productKey;
      });

      this.scrollToMobileProduct(productKey);
    }

    scrollToMobileProduct(productKey) {
      if (!this.mobileMedia.matches) {
        return;
      }

      const trigger = this.querySelector(`[data-product-trigger="${productKey}"]`);
      if (!trigger) {
        return;
      }

      window.requestAnimationFrame(() => {
        const headerOffset = document.querySelector('header')?.offsetHeight || 0;
        const targetTop = trigger.getBoundingClientRect().top + window.scrollY - headerOffset - 12;

        window.scrollTo({
          top: Math.max(targetTop, 0),
          behavior: 'smooth',
        });
      });
    }

    deactivateAllProducts() {
      this.querySelectorAll('[data-product-trigger]').forEach((trigger) => {
        trigger.classList.remove('is-active');
        trigger.setAttribute('aria-expanded', 'false');
      });

      this.querySelectorAll('[data-mobile-panel], [data-desktop-panel]').forEach((panel) => {
        panel.hidden = true;
      });
    }

    clearProductSelection() {
      if (this.productDropdown) {
        this.setDropdownValue(this.productDropdown, '');
      }
    }

    clearCategorySelection() {
      if (this.categoryDropdown) {
        this.setDropdownValue(this.categoryDropdown, '');
      }
    }

    get categoryDropdown() {
      return this.querySelector('[data-category-dropdown]');
    }

    get productDropdown() {
      return this.querySelector('[data-product-dropdown]');
    }

    get keywordInput() {
      return this.querySelector('[data-keyword-input]');
    }
  }

  if (!window.customElements.get('yg-download-center')) {
    window.customElements.define('yg-download-center', YGDownloadCenter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-featured-collection"] && !Shopify.designMode) return;
  try {
    
  class YGFeaturedBanner extends HTMLElement {
    constructor() {
      super();

      this.playVideoButton = this.querySelector('.yg-featured-banner-play-button');
      this.playVideoOnClick = this.playVideoOnClick.bind(this);
    }

    get videoTemplate() {
      if (window.innerWidth > 700) {
        return this.querySelector('template.pc');
      } else {
        return this.querySelector('template.mobile');
      }
    }

    get videoElement() {
      return this.querySelector('.yg-featured-banner-video');
    }

    connectedCallback() {
      this.playVideoButton && this.playVideoButton.addEventListener('click', this.playVideoOnClick);
    }

    disconnectedCallback() {
      this.playVideoButton && this.playVideoButton.removeEventListener('click', this.playVideoOnClick);
    }

    playVideoOnClick() {
      if (!this.videoTemplate) return;

      const videoInTemplate = this.videoTemplate.content.querySelector('video');
      if (!videoInTemplate) return;

      const videoClone = this.videoElement || videoInTemplate.cloneNode(true);

      if (this.videoElement) {
        this.videoElement.style.display = 'block';
      } else {
        this.appendChild(videoClone);
      }

      videoClone.play();
      videoClone.addEventListener(
        'ended',
        () => {
          videoClone.style.display = 'none';
        },
        { once: true }
      );
    }
  }

  if (!customElements.get('yg-featured-banner')) {
    customElements.define('yg-featured-banner', YGFeaturedBanner);
  }

  class YGFeaturedCollectionTabs extends YGUtils {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.setupThumbs();
    }

    setupThumbs() {
      if (typeof Swiper === 'undefined') return;

      this.tabsSwiperEl = this.querySelector('.yg-featured-collection__tabs-swiper');
      this.contentSwiperEl = this.querySelector('.yg-featured-collection__content-swiper');

      if (!this.tabsSwiperEl || !this.contentSwiperEl) return;

      const tabsSwiper = this.tabsSwiperEl.swiper || this.initSwiper(this.tabsSwiperEl);
      if (!tabsSwiper) return;

      tabsSwiper.originalParams.watchSlidesProgress = true;
      tabsSwiper.params.watchSlidesProgress = true;
      tabsSwiper.update();

      const contentSwiper = this.contentSwiperEl.swiper;
      if (contentSwiper && contentSwiper.thumbs && contentSwiper.thumbs.swiper === tabsSwiper) {
        contentSwiper.allowTouchMove = false;
        contentSwiper.update();
        return;
      }

      if (contentSwiper) {
        contentSwiper.destroy(true, true);
      }

      this.contentSwiperEl.swiper = this.initSwiper(this.contentSwiperEl, tabsSwiper);
      if (!this.contentSwiperEl.swiper) return;

      this.contentSwiperEl.swiper.allowTouchMove = false;
      this.contentSwiperEl.swiper.update();
    }
  }

  if (!customElements.get('yg-featured-collection-tabs')) {
    customElements.define('yg-featured-collection-tabs', YGFeaturedCollectionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-group-01"] && !Shopify.designMode) return;
  try {
    
  class YGMediaGroup01 extends HTMLElement {
    constructor() {
      super();
      this.handleModeChange = this.handleModeChange.bind(this);
      this.mobileMedia = window.matchMedia('(max-width: 699px)');
    }

    connectedCallback() {
      this.swiperElement = this.querySelector('.yg-swiper');

      if (!this.swiperElement) {
        return;
      }

      this.updateMobileLayout();
      requestAnimationFrame(() => this.updateMobileLayout());

      if (this.mobileMedia.addEventListener) {
        this.mobileMedia.addEventListener('change', this.handleModeChange);
      }
    }

    disconnectedCallback() {
      if (this.mobileMedia.addEventListener) {
        this.mobileMedia.removeEventListener('change', this.handleModeChange);
      }
    }

    get shouldStackOnMobile() {
      return this.dataset.stackMobile == 'true';
    }

    handleModeChange() {
      this.updateMobileLayout();
    }

    updateMobileLayout() {
      if (!this.swiperElement) {
        return;
      }

      if (this.shouldStackOnMobile && this.mobileMedia.matches) {
        this.classList.add('is-mobile-list');
        this.destroySwiper();
        return;
      }

      this.classList.remove('is-mobile-list');
      this.initSwiper();
    }

    destroySwiper() {
      if (!this.swiperElement.swiper) {
        return;
      }

      this.swiperElement.swiper.destroy(true, true);
      this.swiperElement.swiper = null;
    }

    initSwiper() {
      if (this.swiperElement.swiper) {
        this.swiperElement.swiper.update();
        return;
      }

      if (typeof this.swiperElement.initSwiper !== 'function') {
        return;
      }

      this.swiperElement.swiper = this.swiperElement.initSwiper(this.swiperElement);
    }
  }

  if (!window.customElements.get('yg-media-group-01')) {
    window.customElements.define('yg-media-group-01', YGMediaGroup01);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-newsletter"] && !Shopify.designMode) return;
  try {
    
  class YGNewsletter extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.forms = Array.from(this.querySelectorAll('form'));

      this.forms.forEach((form) => {
        const agreementCheckbox = form.querySelector('[data-newsletter-agreement]');
        const submitButton = form.querySelector('[data-newsletter-submit]');

        if (!agreementCheckbox || !submitButton) return;

        const syncSubmitState = () => {
          submitButton.disabled = !agreementCheckbox.checked;
        };

        agreementCheckbox.addEventListener('change', syncSubmitState);
        syncSubmitState();
      });
    }
  }

  if (!window.customElements.get('yg-newsletter')) {
    window.customElements.define('yg-newsletter', YGNewsletter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-support-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGProductSupportTabs extends HTMLElement {
    constructor() {
      super();

      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleHashChange = this.handleHashChange.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      window.addEventListener('hashchange', this.handleHashChange);

      const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
      const initialTab = this.dataset.initialTab || (selectedTab ? selectedTab.dataset.tabTarget : '');
      this.activateTab(this.getRequestedTab() || initialTab);

      if (this.getRequestedTab()) {
        requestAnimationFrame(() => this.scrollIntoView({ behavior: 'smooth', block: 'start' }));
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      window.removeEventListener('hashchange', this.handleHashChange);
    }

    handleClick(event) {
      const nextTab = event.target.closest('[role="tab"]');

      if (!nextTab || !this.contains(nextTab)) return;

      this.activateTab(nextTab.dataset.tabTarget);
    }

    handleKeydown(event) {
      const currentTab = event.target.closest('[role="tab"]');

      if (!currentTab || !this.contains(currentTab) || this.tabs.length === 0) return;

      const currentIndex = this.tabs.indexOf(currentTab);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();

      const nextTab = this.tabs[nextIndex];

      if (!nextTab) return;

      this.activateTab(nextTab.dataset.tabTarget);
      nextTab.focus();
    }

    handleHashChange() {
      const tabName = this.getRequestedTab();

      if (!tabName) return;

      this.activateTab(tabName);
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    getRequestedTab() {
      const targetId = window.location.hash.slice(1);

      if (targetId !== this.id) return '';

      return new URLSearchParams(window.location.search).get('tab') || '';
    }

    activateTab(tabName) {
      const fallbackTab = this.tabs[0] ? this.tabs[0].dataset.tabTarget : '';
      const activeTabName = this.tabs.some((tab) => tab.dataset.tabTarget === tabName) ? tabName : fallbackTab;

      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tabTarget === activeTabName;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.panel === activeTabName;

        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });

      this.dataset.activeTab = activeTabName || '';
    }
  }

  if (!window.customElements.get('yg-product-support-tabs')) {
    window.customElements.define('yg-product-support-tabs', YGProductSupportTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-specifications-preview"] && !Shopify.designMode) return;
  try {
    
  class YGSpecificationsPreview extends HTMLElement {
    constructor() {
      super();

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.scroller = this.querySelector('[data-scroller]');
      this.progressTrack = this.querySelector('[data-progress-track]');
      this.progressBar = this.querySelector('[data-progress-bar]');
      this.table = this.querySelector('.yg-specifications-preview__table');

      if (!this.scroller || !this.progressTrack || !this.progressBar) return;

      this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.updateProgress();
        });

        this.resizeObserver.observe(this.scroller);

        if (this.table) {
          this.resizeObserver.observe(this.table);
        }
      }

      requestAnimationFrame(() => {
        this.updateProgress();
      });
    }

    disconnectedCallback() {
      if (this.scroller) {
        this.scroller.removeEventListener('scroll', this.handleScroll);
      }

      window.removeEventListener('resize', this.handleResize);

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    handleScroll() {
      this.updateProgress();
    }

    handleResize() {
      this.updateProgress();
    }

    updateProgress() {
      if (!this.scroller || !this.progressTrack || !this.progressBar) return;

      const maxScrollLeft = this.scroller.scrollWidth - this.scroller.clientWidth;

      if (maxScrollLeft <= 0) {
        this.progressTrack.hidden = true;
        this.progressBar.style.width = '100%';
        this.progressBar.style.transform = 'translateX(0)';
        return;
      }

      const widthPercent = (this.scroller.clientWidth / this.scroller.scrollWidth) * 100;
      const offsetPercent = (this.scroller.scrollLeft / maxScrollLeft) * (100 - widthPercent);

      this.progressTrack.hidden = false;
      this.progressBar.style.width = `${widthPercent}%`;
      this.progressBar.style.transform = `translateX(${offsetPercent}%)`;
    }
  }

  if (!window.customElements.get('yg-specifications-preview')) {
    window.customElements.define('yg-specifications-preview', YGSpecificationsPreview);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-media-swiper"] && !Shopify.designMode) return;
  try {
    
  class YGMediaTabsSwiper extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.activeIndex = 0;
      this.handleTabClick = this.handleTabClick.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.waitForReady();
    }

    get mediaSwiperElement() {
      return this.querySelector('.yg-tabs-media-swiper__media-swiper');
    }

    get contentSwiperElement() {
      return this.querySelector('.yg-tabs-media-swiper__content-swiper');
    }

    get tabsTitle() {
      return this.querySelector(`yg-tabs-title[data-id="${this.dataset.tabsId}"]`);
    }

    get tabItems() {
      return Array.from(this.tabsTitle?.children || []);
    }

    get panelSlides() {
      return Array.from(this.querySelectorAll('.yg-tabs-media-swiper__content-slide'));
    }

    get mediaSlides() {
      return Array.from(this.querySelectorAll('.yg-tabs-media-swiper__media-swiper .swiper-slide'));
    }

    waitForReady(attempt = 0) {
      if (this.mediaSwiperElement?.swiper && this.contentSwiperElement?.swiper && this.tabsTitle) {
        this.setup();
        return;
      }

      if (attempt > 30) return;

      window.requestAnimationFrame(() => this.waitForReady(attempt + 1));
    }

    setup() {
      this.mediaSwiper = this.mediaSwiperElement.swiper;
      this.contentSwiper = this.contentSwiperElement.swiper;
      this.mediaSwiper.params.fadeEffect = {
        ...(this.mediaSwiper.params.fadeEffect || {}),
        crossFade: true,
      };
      this.contentSwiper.params.fadeEffect = {
        ...(this.contentSwiper.params.fadeEffect || {}),
        crossFade: true,
      };
      this.mediaSwiper.params.autoHeight = true;
      this.contentSwiper.params.autoHeight = true;

      this.tabsTitle.setAttribute('role', 'tablist');
      this.tabsTitle.addEventListener('click', this.handleTabClick);

      this.tabItems.forEach((item, index) => {
        item.setAttribute('role', 'tab');
        item.dataset.tabIndex ||= `${index}`;
      });

      this.panelSlides.forEach((panel, index) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
      });

      this.mediaSwiper.on('slideChange', () => {
        this.syncToIndex(this.mediaSwiper.realIndex ?? this.mediaSwiper.activeIndex);
      });

      this.contentSwiper.on('slideChange', () => {
        this.syncToIndex(this.contentSwiper.realIndex ?? this.contentSwiper.activeIndex);
      });

      this.syncToIndex(0, true, 'auto');
    }

    handleTabClick(event) {
      const item = event.target.closest('.tab-title');

      if (!item) return;

      const index = Number(item.dataset.tabIndex);

      if (Number.isNaN(index)) return;

      window.requestAnimationFrame(() => {
        this.syncToIndex(index, true);
      });
    }

    syncToIndex(index, force = false, scrollBehavior = 'smooth') {
      if (index < 0 || index >= this.tabItems.length) return;
      if (!force && index === this.activeIndex) return;

      this.activeIndex = index;
      this.syncTabs(index, scrollBehavior);
      this.syncPanels(index);
      this.syncSwiper(this.mediaSwiper, index);
      this.syncSwiper(this.contentSwiper, index);
      this.syncVideos(index);
      this.updateHeights();
    }

    syncSwiper(swiper, index) {
      if (!swiper) return;

      const currentIndex = swiper.realIndex ?? swiper.activeIndex;

      if (currentIndex !== index) {
        swiper.slideTo(index);
      }
    }

    syncTabs(index, scrollBehavior = 'smooth') {
      const target = this.tabItems[index];

      this.tabItems.forEach((item, itemIndex) => {
        const isActive = itemIndex === index;

        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      if (target) {
        this.tabsTitle.updateStyle?.(target);
        this.scrollTabIntoCenter(target, scrollBehavior);
      }
    }

    syncPanels(index) {
      this.panelSlides.forEach((panel, panelIndex) => {
        panel.setAttribute('aria-hidden', panelIndex === index ? 'false' : 'true');
      });
    }

    syncVideos(index) {
      this.mediaSlides.forEach((slide, slideIndex) => {
        slide.querySelectorAll('yg-video').forEach((videoElement) => {
          if (slideIndex === index) {
            videoElement.playVideo?.();
          } else {
            videoElement.pauseVideo?.();
          }
        });
      });
    }

    updateHeights() {
      this.mediaSwiper?.updateAutoHeight?.(300);
      this.contentSwiper?.updateAutoHeight?.(300);
    }

    scrollTabIntoCenter(target, behavior = 'smooth') {
      const scrollContainer = this.tabsTitle?.closest('.yg-scroll-container');

      if (!scrollContainer || !target) return;

      const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

      if (maxScrollLeft <= 0) return;

      const nextScrollLeft = Math.min(
        Math.max(target.offsetLeft + target.offsetWidth / 2 - scrollContainer.clientWidth / 2, 0),
        maxScrollLeft
      );

      scrollContainer.scrollTo({
        left: nextScrollLeft,
        behavior,
      });
    }
  }

  if (!window.customElements.get('yg-media-tabs-swiper')) {
    window.customElements.define('yg-media-tabs-swiper', YGMediaTabsSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-banner"] && !Shopify.designMode) return;
  try {
    
  class YGVideoBanner extends HTMLElement {
    constructor() {
      super();
      this.handleControlClick = this.handleControlClick.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.rafId = null;
    }

    connectedCallback() {
      this.controlButton = this.querySelector('[data-video-control]');
      this.videoElements = Array.from(this.querySelectorAll('.yg-video-banner__video-element'));

      if (!this.controlButton || !this.videoElements.length) return;

      this.controlButton.addEventListener('click', this.handleControlClick);
      window.addEventListener('resize', this.handleResize);

      this.videoElements.forEach((video) => {
        video.addEventListener('play', () => this.handleVideoStateChange(video));
        video.addEventListener('pause', () => this.handleVideoStateChange(video));
        video.addEventListener('ended', () => this.handleVideoStateChange(video));
        video.addEventListener('loadedmetadata', () => this.updateProgress());
        video.addEventListener('timeupdate', () => this.updateProgress());
      });

      this.syncState();
    }

    disconnectedCallback() {
      this.controlButton?.removeEventListener('click', this.handleControlClick);
      window.removeEventListener('resize', this.handleResize);

      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
      }
    }

    get activeVideo() {
      return (
        this.videoElements.find((video) => {
          const mediaItem = video.closest('.yg-video-banner__media-item');
          return mediaItem && mediaItem.offsetParent !== null;
        }) || this.videoElements[0]
      );
    }

    handleControlClick() {
      const video = this.activeVideo;
      if (!video) return;

      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    }

    handleResize() {
      this.syncState();
    }

    handleVideoStateChange(video) {
      if (video !== this.activeVideo) return;

      this.syncButtonState();

      if (!video.paused && !video.ended) {
        this.startProgressLoop();
      } else {
        this.stopProgressLoop();
      }

      this.updateProgress();
    }

    syncState() {
      this.syncButtonState();
      this.updateProgress();

      const video = this.activeVideo;
      if (video && !video.paused && !video.ended) {
        this.startProgressLoop();
      } else {
        this.stopProgressLoop();
      }
    }

    syncButtonState() {
      const video = this.activeVideo;
      if (!video || !this.controlButton) return;

      const isPlaying = !video.paused && !video.ended;
      this.controlButton.dataset.state = isPlaying ? 'pause' : 'play';
      this.controlButton.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
    }

    updateProgress() {
      const video = this.activeVideo;
      if (!video) return;

      let progress = 0;
      if (video.duration && Number.isFinite(video.duration) && video.duration > 0) {
        progress = Math.min((video.currentTime / video.duration) * 100, 100);
      }

      this.style.setProperty('--yg-video-banner-control-progress', `${progress / 100}`);
    }

    startProgressLoop() {
      if (this.rafId) return;

      const step = () => {
        this.updateProgress();
        const video = this.activeVideo;

        if (video && !video.paused && !video.ended) {
          this.rafId = requestAnimationFrame(step);
        } else {
          this.rafId = null;
        }
      };

      this.rafId = requestAnimationFrame(step);
    }

    stopProgressLoop() {
      if (!this.rafId) return;
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }
  if (!window.customElements.get('yg-video-banner')) {
    window.customElements.define('yg-video-banner', YGVideoBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
